import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@ibk/shared-auth';
import { useGetProductRelationShips } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { Loading } from '@ibk/shared-ui';
import { clearDeepLinkStorage, DeepLinkModule, getDeepLinkFromStorage } from '@ibk/shared-utils';
export const DeepLinkResolver = () => {
    const navigate = useNavigate();
    const { data: auth } = useAuth();
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFeatureFlags } = useFeatureFlag(auth?.personId, {
        autoLoad: true,
    });
    const { getBillingProduct } = useGetProductRelationShips();
    const [isResolving, setIsResolving] = useState(true);
    const hasResolved = useRef(false);
    useEffect(() => {
        if (hasResolved.current)
            return;
        const resolveDeepLink = () => {
            if (!auth?.personId) {
                return;
            }
            if (isLoadingFeatureFlags) {
                return;
            }
            hasResolved.current = true;
            const deepLinkData = getDeepLinkFromStorage();
            if (!deepLinkData) {
                navigate('/home', { replace: true });
                return;
            }
            let destination;
            if (deepLinkData.module === DeepLinkModule.COBRANCAS) {
                destination = resolveCobrancas(deepLinkData.params);
            }
            else if (deepLinkData.module === DeepLinkModule.BENEFICIOS) {
                destination = resolveBeneficios();
            }
            else {
                destination = '/home';
            }
            clearDeepLinkStorage();
            navigate(destination, { replace: true });
            setIsResolving(false);
        };
        const resolveCobrancas = (_params) => {
            const hasModuleBilling = isFeatureFlagWhiteListed(FeatureFlagUseCase.NEW_IBKS_ESCRITORIO_MODULE_BILLING);
            if (!hasModuleBilling) {
                return '/home';
            }
            return '/cobrancas';
        };
        const resolveBeneficios = () => {
            return '/beneficios';
        };
        resolveDeepLink();
    }, [navigate, isFeatureFlagWhiteListed, getBillingProduct, auth, isLoadingFeatureFlags]);
    if (isResolving) {
        return _jsx(Loading, { fullScreen: true });
    }
    return null;
};
